export const MaterialDetails = {
    API: 'IntegrationLog'
}

export const MaterialDetailsAPIConstant = {
    getIntergrationLogDetails: MaterialDetails.API +'/GetIntegrationLogDetails',
    getProductVariantById: MaterialDetails.API +'/GetProductVariantById',
    getDataWithComparison: MaterialDetails.API +'/GetDataWithComparison',
    
}